export type ServerPathSeparator = '\\' | '/';

export function getServerPathSeparator(path: string): ServerPathSeparator {
  const trimmed = path.trim();
  if (trimmed.includes('\\')) return '\\';
  return '/';
}

export function normalizeServerDirectoryPath(path: string): string {
  const trimmed = path.trim();
  if (!trimmed) return '';

  const separator = getServerPathSeparator(trimmed);

  if (trimmed === '/') return '/';
  if (separator === '\\' && /^[a-zA-Z]:\\$/.test(trimmed)) return trimmed;

  let normalized = trimmed;
  while (normalized.endsWith(separator)) {
    normalized = normalized.slice(0, -1);
  }

  return normalized;
}

export function joinServerPath(directoryPath: string, name: string): string {
  const normalizedDir = normalizeServerDirectoryPath(directoryPath);
  if (!normalizedDir) return name;

  const separator = getServerPathSeparator(normalizedDir);
  const base = normalizedDir.endsWith(separator) ? normalizedDir : `${normalizedDir}${separator}`;
  return `${base}${name}`;
}

export function getServerParentDirectory(path: string): string {
  const normalized = normalizeServerDirectoryPath(path);
  if (!normalized) return '';

  const separator = getServerPathSeparator(normalized);

  if (normalized === '/') return '/';
  if (separator === '\\' && /^[a-zA-Z]:\\$/.test(normalized)) return normalized;

  const lastSeparatorIndex = normalized.lastIndexOf(separator);
  if (lastSeparatorIndex === -1) return '';

  const parent = normalized.slice(0, lastSeparatorIndex);
  if (separator === '\\' && /^[a-zA-Z]:$/.test(parent)) {
    return `${parent}\\`;
  }

  return parent || (separator === '/' ? '/' : '');
}

export function getServerDirectoryFromFilePath(filePath: string): string | null {
  const trimmed = filePath.trim();
  if (!trimmed) return null;

  const separator = getServerPathSeparator(trimmed);
  const lastSeparatorIndex = trimmed.lastIndexOf(separator);
  if (lastSeparatorIndex === -1) return null;

  const dir = trimmed.slice(0, lastSeparatorIndex);
  if (!dir) return separator === '/' ? '/' : null;

  if (separator === '\\' && /^[a-zA-Z]:$/.test(dir)) {
    return `${dir}\\`;
  }

  return dir;
}

